import { SET_NAME, ACCEPT_AGREEMENT, SET_TOOLTIP } from '../types';

export const searchInitialState = {
  name: '',
  showAgreement: true,
  lpHideDocSlicerTooltip: 0,
};

const userReducer = (state = searchInitialState, action) => {
  switch (action.type) {
    case SET_NAME:
      let name = action.name;
      return {
        ...state,
        name,
      };

    case ACCEPT_AGREEMENT:
      return {
        ...state,
        showAgreement: true,
      };

    case SET_TOOLTIP:
      return {
        ...state,
        lpHideDocSlicerTooltip: action.value,
      };

    default:
      return state;
  }
};

export default userReducer;
